import {
  Box3,
  PerspectiveCamera,
  Vector3,
  MeshStandardMaterial,
  Mesh,
  Color,
  ShaderMaterial,
  CameraHelper,
  BufferGeometry,
  DoubleSide,
  BufferAttribute,
  Quaternion,
  MeshBasicMaterial,
} from "three";
import { message } from "antd";
import { BaseManager } from "./BaseManager.js";
import { EventManagerCommand } from "./EventManager.js";
import { CommonCommand } from "../command/commonCommand.js";
import { setVrData } from "../../store/module/app";
import store from "../../store/index.js";
export class VRSettingManager extends BaseManager {
  constructor(manager) {
    super(manager);
  }

  init(manager) {
    this.el = manager.el;
    this.scene = manager.sceneManager.scene;
    this.transformcontrol = manager.sceneManager.transformcontrol;
    this.model = null;
    this.VRset = false; //是否开启vr模式
    this.VRPlaneColor = "#00ffff"; //地板的颜色
    this.planeNodes = []; //存储地板对象
    this.Vrpostion = null; //VR设置的位置属性
    this.cloneModel = null; //克隆专属的模型
    this.cloneModels = []; //记录克隆出来的模型
    this.camer = new PerspectiveCamera(
      70,
      this.el.clientWidth / this.el.clientHeight,
      0.1,
      1000
    );

    this.VRPlaneMat = new MeshStandardMaterial({ color: this.VRPlaneColor });

    this._loadEmptyPeople("/model/lp_man/scene.gltf");
    //this._loadPeople("/model/viewer.glb");

    this.camerhelp = new CameraHelper(this.camer);

    this.modelScale = 0.01;

    this.VRNews = {
      position: [], //VR设置的位置
      planeNames: [], //模型设定的面板名称
    };
    //对按钮的控制面板
    this.buttenKeys = {
      VRKey: false,
      PlaneKey: false,
      PositionKey: false,
    };

    this._updateWebUI(); // 初始化前端颜色
  }

  update(dt) {
    super.update(dt);
  }

  clear() {
    this.el = null;
    this.scene = null;
    this.transformcontrol = null;
    this.model = null;
    this.planeNodes = []; //设置的模型的名称
    this.Vrpostion = null; //VR设置的位置属性

    this.cloneModels = []; //记录克隆出来的模型
    this.camer = null;
    this.loader = null;

    if (this.camerhelp) this.camerhelp.removeFromParent();
    this.camerhelp = null;

    this.VRNews = null;

    this.buttenKeys = null;

    super.clear();
  }

  setInitData(data) {
    if (data) this.VRNews = data;
    //console.log("输出的模型的数据为", this.VRNews, data);

    this.BingerModelSet(false);

    // 缓存已设置的地面
    if (this.VRNews.planeNames) {
      for (var j = 0; j < this.manager.sceneManager.singleModels.length; j++) {
        this.manager.sceneManager.singleModels[j].traverse((node) => {
          this.VRNews.planeNames.forEach((item) => {
            if (node.nodeId === item) {
              this.planeNodes.push(node);
            }
          });
        });
      }
    }

    // 等待模型加载完成
    // if (this.manager.eventManager) {
    //   this.waitModelLoadFunc = this._waitModelLoad.bind(this);
    //   this.manager.eventManager.addEventListener(
    //     EventManagerCommand.modelAllLoaded,
    //     this.waitModelLoadFunc
    //   );
    // }

    if (!this.cloneModel) {
      // 等待人物模型加载完成
      const waitInterval = setInterval(() => {
        if (this.cloneModel) {
          this.initScene(this.VRNews);
          clearInterval(waitInterval);
        }
      }, 500);
    } else this.initScene(this.VRNews);
  }

  _waitModelLoad() {
    this.initScene(this.VRNews);
    this.manager.eventManager.removeEventListener(
      EventManagerCommand.modelAllLoaded,
      this.waitModelLoadFunc
    );
  }

  switchModule() {
    // 切换到setting
    //   if (this.buttenKeys && this.buttenKeys.VRKey) {
    //     this.BingerModelSet(true);
    //   }
    // // 切换到其他面板但是VR设置还开启着
    // else if (this.buttenKeys && this.buttenKeys.VRKey) {
    //   this.BingerModelSet(false);
    // }
  }

  /**
   * 返回按钮的控制的页面
   */
  returnKeys() {
    return this.buttenKeys;
  }
  /**
   * 对数据库的里面的数据进行加载
   */
  initScene(data = null) {
    if (data) {
      //设置模型的位置
      if (data.position) {
        data.position.forEach((temp) => {
          let cloneM = this.cloneModel.clone();
          cloneM.traverse((node) => {
            node._parent = cloneM;
            node._meshtag = "cloneModel";
          });
          cloneM.visible = false;
          this.scene.add(cloneM);
          this.cloneModels.push(cloneM);
          cloneM.position.set(temp.x, temp.y, temp.z);

          //this.manager.vrManager.setModelComponent(cloneM);
        });
      }
    }
  }

  _loadEmptyPeople(url) {
    this.manager.loadManager.loadScene(url, (gltf) => {
      this.cloneModel = gltf.scene.children[0];
      if (this.manager.interface.useShadow) {
        this.cloneModel.traverse((node) => {
          node.castShadow = true; //默认关闭阴影
          node.receiveShadow = true; //默认开启接收阴影
        });
      }

      this.cloneModel.scale.set(0.0055, 0.0055, 0.0055);
    });
  }

  /**
   * 导入vr设置模型
   * @param {*} url
   */
  _loadPeople(url) {
    this.manager.loadManager.loadScene(url, (gltf) => {
      let model = gltf.scene;
      this.model = model;
      // model.roa
      model.rotateX(Math.PI / 2);
      model.rotateZ(Math.PI);
      this.scene.add(model);
      this.model.visible = false;
      //model.scale.set(0.1, 0.1, 0.1);
      this._setVrModel(model);
    });
  }
  /**
   * 对vr模型进行基本的设置
   * @param {*} model
   */
  _setVrModel(model) {
    let box = new Box3().expandByObject(model);
    let center = box.getCenter(new Vector3());
    let size = box.getSize(new Vector3());
    let postion = new Vector3(center.x, center.y + size.y / 2.5, center.z);
    this.camer.position.copy(postion);
    model.attach(this.camer);
    this.scene.add(this.camerhelp);
    this.camerhelp.visible = false;
    let mesh = this._getAureole(size.x, size.y / 4, 0xffff00);
    model.attach(mesh);

    model.scale.set(0.01, 0.01, 0.01);
  }

  getVrData() {
    return this.VRNews;
  }

  /**
   * 开启VR模型设置模式
   * @param {*} key true 开启  false 关闭
   */
  BingerModelSet(key, needHistory = true) {
    if (this.buttenKeys.VRKey === key) return;
    // 历史记录
    if (needHistory) {
      const state = {
        oldState: this.buttenKeys.VRKey,
        newState: key,
      };
      const cmd = new CommonCommand(
        state,
        (arg) => {
          this.BingerModelSet(arg.oldState, false);
          this._updateWebUI();
        },
        (arg) => {
          this.BingerModelSet(arg.newState, false);
          this._updateWebUI();
        }
      );
      this.manager.addHistory(cmd);
    }

    this.buttenKeys.VRKey = key;

    if (key) {
      if (this.model) {
        this.model.visible = true;
        this.transformcontrol.attach(this.model);
        this.transformcontrol.enabled = true;
        this.camerhelp.visible = true;
        this.transformcontrol.mode = "translate";
        this.transformcontrol.setSpace("global");
      }

      if (this.buttenKeys.PositionKey && this.cloneModels) {
        this.cloneModels.forEach((data) => {
          //this.VRNews.position.push(data.name);
          data.visible = true;
        });
      }
    } else {
      if (this.model) this.model.visible = false;
      this.transformcontrol.detach();
      if (this.cloneModels) {
        this.cloneModels.forEach((data) => {
          //this.VRNews.position.push(data.name);
          data.visible = false;
        });
      }

      //this.transformcontrol.enabled =false;
      this.camerhelp.visible = false;
      if (this.planeNodes) {
        this.planeNodes.forEach((data) => {
          if (data.userData._vrSetMat) {
            data.material = data.userData._vrSetMat;
            delete data.userData._vrSetMat;
          }
        });
      }
    }
  }

  /**
   * 对地板的编辑设定
   * @param {*} order "set" "confirm" "delect" "color"
   */
  editorPlane(order = null, object = null, needHistory = true) {
    //进行点击物体 添加地板
    if (order === "set") {
      if (this.manager.sceneManager.paperPlane) {
        if (object === this.manager.sceneManager.paperPlane) {
          if (this.manager.isInVR()) {
            this.manager.vrManager.makeSystemTip("该物体固定为地形，不可选择");
          } else message.info("该物体固定为地形，不可选择");
          return;
        }
      }

      let key = false;
      //查看有没有已经添加的模型
      for (let i = 0; i < this.planeNodes.length; i++) {
        if (this.planeNodes[i] === object) {
          //已经有模型 删除
          this.planeNodes.splice(i, 1);
          key = true;
          break;
        }
      }
      if (!key) {
        //如果第一次加入数组
        object.userData._vrSetMat = object.material;
        object.material = this.VRPlaneMat;
        this.planeNodes.push(object);

        // 用于VR模式下的设置
        if (this.manager.isInVR()) {
          this.manager.vrManager.setPlaneComponent(object);
        }
      } else {
        //不是
        if (object.userData._vrSetMat) {
          object.material = object.userData._vrSetMat;
          delete object.userData._vrSetMat;
        }

        // 用于VR模式下的设置
        if (this.manager.isInVR()) {
          if (object._meshtag) delete object._meshtag;
          this.manager.vrManager.removeModelComponent(object);
        }
      }

      // 历史记录相关
      if (needHistory) {
        const state = {
          obj: object,
        };
        const cmd = new CommonCommand(
          state,
          (arg) => {
            this.editorPlane("set", arg.obj, false);
          },
          (arg) => {
            this.editorPlane("set", arg.obj, false);
          }
        );
        this.manager.addHistory(cmd);
      }
    } else if (order === "confirm") {
      //对设定好的地板进行设定
      let names = [];
      this.planeNodes.forEach((data) => {
        if (data.userData._vrSetMat) {
          //data.material = data.userData._vrSetMat;
          //delete data.userData._vrSetMat;
          names.push(data.nodeId);
        }
      });

      // 历史记录相关
      if (needHistory) {
        const state = {
          oldState: [].concat(this.VRNews.planeNames),
          newState: [].concat(names),
        };
        const cmd = new CommonCommand(
          state,
          (arg) => {
            this.VRNews.planeNames = arg.oldState;
          },
          (arg) => {
            this.VRNews.planeNames = arg.newState;
          }
        );
        this.manager.addHistory(cmd);
      }

      this.VRNews.planeNames = names;
      if (needHistory) message.info("地板确认成功");
    } else if (order === "delect") {
      // 历史记录相关
      if (needHistory) {
        const state = {
          oldState: [].concat(this.planeNodes),
        };
        const cmd = new CommonCommand(
          state,
          (arg) => {
            for (var i = 0; i < arg.oldState.length; i++) {
              this.editorPlane("set", arg.oldState[i], false);
            }
          },
          (arg) => {
            this.editorPlane("delect", null, false);
          }
        );

        this.manager.addHistory(cmd);
      }

      //对所有的地板进行清除
      this.planeNodes.forEach((data) => {
        if (data.userData._vrSetMat) {
          data.material = data.userData._vrSetMat;
          delete data.userData._vrSetMat;
        }
      });
      this.planeNodes = [];
      this.VRNews.planeNames = []; //存储的信息变换完
      if (needHistory) message.info("地板删除成功");
    } else if (order === "color") {
      // 历史记录相关
      if (needHistory) {
        const state = {
          oldState: this.VRPlaneColor,
          newState: object,
        };
        const cmd = new CommonCommand(
          state,
          (arg) => {
            this.editorPlane("color", arg.oldState, false);
            //  通知前端更新
            this._updateWebUI();
          },
          (arg) => {
            this.editorPlane("color", arg.newState, false);
            //  通知前端更新
            this._updateWebUI();
          }
        );
        this.manager.addHistory(cmd);
      }
      //console.log("color", object);

      this.VRPlaneColor = object;
      this.VRPlaneMat.color = new Color(object);
    }
  }
  /**
   * 开始设置地板的控制
   * @param {*} key
   */
  BingerPlaneSet(key = false, needHistory = true) {
    if (this.buttenKeys.PlaneKey === key) return;
    // 历史记录相关
    if (needHistory) {
      const state = {
        oldState: this.buttenKeys.PlaneKey,
        oldPositionState: this.buttenKeys.PositionKey,
        newState: key,
      };
      const cmd = new CommonCommand(
        state,
        (arg) => {
          this.BingerPlaneSet(arg.oldState, false);
          this.BingerPostionSet(arg.oldPositionState, false);
          this._updateWebUI();
        },
        (arg) => {
          this.BingerPlaneSet(arg.newState, false);
          if (arg.newState) this.BingerPostionSet(false, false);
          this._updateWebUI();
        }
      );
      this.manager.addHistory(cmd);
    }
    if (key) {
      this.BingerPostionSet(false, false);
    }
    this.buttenKeys.PlaneKey = key;
    //并对服务器的数据进行读写
    if (key && this.VRNews.planeNames) {
      if (this.planeNodes && this.planeNodes.length > 0) {
        for (var i = 0; i < this.planeNodes.length; i++) {
          this.planeNodes[i].userData._vrSetMat = this.planeNodes[i].material;
          this.planeNodes[i].material = this.VRPlaneMat;
        }
      }
    } else {
      this.planeNodes.forEach((data) => {
        if (data.userData._vrSetMat) {
          data.material = data.userData._vrSetMat;
          delete data.userData._vrSetMat;
        }
      });
    }
  }
  /**
   * 模型位置的设定
   * @param {*} key
   */
  BingerPostionSet(key = false, needHistory = true) {
    if (this.buttenKeys.PositionKey === key) return;
    // 历史记录相关
    if (needHistory) {
      const state = {
        oldState: this.buttenKeys.PositionKey,
        oldPlaneState: this.buttenKeys.PlaneKey,
        newState: key,
      };
      const cmd = new CommonCommand(
        state,
        (arg) => {
          this.BingerPostionSet(arg.oldState, false);
          this.BingerPlaneSet(arg.oldPlaneState, false);
          this._updateWebUI();
        },
        (arg) => {
          this.BingerPostionSet(arg.newState, false);
          if (arg.newState) this.BingerPlaneSet(false, false);
          this._updateWebUI();
        }
      );
      this.manager.addHistory(cmd);
    }

    if (key) {
      this.BingerPlaneSet(false, false);
    }
    this.buttenKeys.PositionKey = key;
    this.cloneModels.forEach((data) => {
      data.visible = key;
    });
  }
  /**
   * 设置当前的位置的
   * @param {*} order "set" "confirm" "delect"
   * @param {*} data  鼠标响应事情返回的内容
   */
  editorPostion(order = null, data = null, needHistory = true) {
    if (order === "set") {
      //console.log("输出的模型的点击位置是", order, data);
      //出身位置只能设定在地板上
      let object = data.object;
      let target;
      //已经有模型 删除
      if (object._meshtag && object._meshtag === "cloneModel") {
        let parent = object._parent;
        // 用于VR模式下的设置
        if (this.manager.isInVR()) {
          this.manager.vrManager.removeModelComponent(parent);
        }
        this.scene.remove(parent);
        target = parent;
        const index = this.cloneModels.indexOf(parent);
        if (index >= 0) this.cloneModels.splice(index, 1);
      } else {
        if (
          this.manager.sceneManager.paperPlane &&
          object === this.manager.sceneManager.paperPlane
        ) {
          let cloneM = this.cloneModel.clone();
          cloneM.traverse((node) => {
            node._parent = cloneM;
            node._meshtag = "cloneModel";
          });
          cloneM.visible = true;
          this.scene.add(cloneM);
          this.cloneModels.push(cloneM);
          cloneM.position.copy(data.point);
          target = cloneM;

          // 用于VR模式下的设置
          if (this.manager.isInVR()) {
            this.manager.vrManager.setModelComponent(cloneM);
          }
        } else {
          this.VRNews.planeNames.forEach((data1) => {
            //如果是设定好的地板
            if (data1 === object.nodeId) {
              let cloneM = this.cloneModel.clone();
              cloneM.traverse((node) => {
                node._parent = cloneM;
                node._meshtag = "cloneModel";
              });
              cloneM.visible = true;
              this.scene.add(cloneM);
              this.cloneModels.push(cloneM);
              cloneM.position.copy(data.point);
              target = cloneM;

              // 用于VR模式下的设置
              if (this.manager.isInVR()) {
                this.manager.vrManager.setModelComponent(cloneM);
              }
            }
          });
        }
      }

      // 历史记录相关
      if (needHistory) {
        const state = {
          obj: data.object,
          target: target,
        };
        const cmd = new CommonCommand(
          state,
          (arg) => {
            if (arg.obj._meshtag && arg.obj._meshtag === "cloneModel") {
              this.scene.add(arg.target);
              this.cloneModels.push(arg.target);
            } else {
              this.scene.remove(arg.target);
              const index = this.cloneModels.indexOf(arg.target);
              if (index >= 0) this.cloneModels.splice(index, 1);
            }
          },
          (arg) => {
            if (arg.obj._meshtag && arg.obj._meshtag === "cloneModel") {
              this.scene.remove(arg.target);
              const index = this.cloneModels.indexOf(arg.target);
              if (index >= 0) this.cloneModels.splice(index, 1);
            } else {
              this.scene.add(arg.target);
              this.cloneModels.push(arg.target);
            }
          }
        );
        this.manager.addHistory(cmd);
      }
    } else if (order === "confirm") {
      // 历史记录相关
      if (needHistory) {
        const state = {
          oldState: [].concat(this.VRNews.position),
          newState: [].concat(this.cloneModels.map((model) => model.position)),
        };
        const cmd = new CommonCommand(
          state,
          (arg) => {
            this.VRNews.position = arg.oldState;
          },
          (arg) => {
            this.VRNews.position = arg.newState;
          }
        );
        this.manager.addHistory(cmd);
      }

      this.VRNews.position = [];
      this.cloneModels.forEach((data) => {
        //console.log(data);
        this.VRNews.position.push(data.position);
      });
      //console.log(this.VRNews);
      if (needHistory) message.info("位置确认成功");
    } else if (order === "delect") {
      // 历史记录相关
      if (needHistory) {
        const state = {
          oldPositions: [].concat(this.VRNews.position),
          oldState: [].concat(this.cloneModels),
        };
        const cmd = new CommonCommand(
          state,
          (arg) => {
            for (var i = 0; i < arg.oldState.length; i++) {
              this.scene.add(arg.oldState[i]);
            }
            this.VRNews.position = arg.oldPositions;
          },
          (arg) => {
            this.VRNews.position = [];
            for (var i = 0; i < arg.oldState.length; i++) {
              this.scene.remove(arg.oldState[i]);
            }
          }
        );
        this.manager.addHistory(cmd);
      }

      this.VRNews.position = [];
      this.cloneModels.forEach((data) => {
        this.scene.remove(data);
      });
      this.cloneModels = [];
      message.info("位置删除成功");
    }
  }

  _updateWebUI() {
    if (this.manager.isInVR()) return;
    // const data = {
    //   enabled: this.buttenKeys.VRKey,
    //   floor_enabled: this.buttenKeys.PlaneKey,
    //   position_enabled: this.buttenKeys.PositionKey,
    //   floor_color: this.VRPlaneColor,
    // };
    // store.dispatch(setVrData(data));
    store.dispatch(
      setVrData((prevState) => ({
        enabled: this.buttenKeys.VRKey,
        floor_enabled: this.buttenKeys.PlaneKey,
        position_enabled: this.buttenKeys.PositionKey,
        floor_color: this.VRPlaneColor,
      }))
    );
  }

  /**
   * 生成柱状渐变光环
   * @param {*} radius 半径
   * @param {*} height 高度
   * @param {*} color 颜色
   * @returns
   */
  _getAureole(radius, height, color) {
    let geo, mat;
    let segment = 64;
    //geo
    {
      let bottomPos = [];
      let topPos = [];
      let angleOffset = (Math.PI * 2) / segment;
      for (var j = 0; j < segment; j++) {
        let x = Math.cos(angleOffset * j) * radius;
        let z = Math.sin(angleOffset * j) * radius;
        bottomPos.push(new Vector3(x, 0, z));
        topPos.push(new Vector3(x, height, z));
      }
      bottomPos = bottomPos.concat(topPos);

      let face = [];
      for (var i = 0; i < segment; i++) {
        if (i !== segment - 1) {
          face.push(i + segment + 1);
          face.push(i);
          face.push(i + segment);
          face.push(i);
          face.push(i + segment + 1);
          face.push(i + 1);
        } else {
          face.push(segment);
          face.push(i);
          face.push(i + segment);
          face.push(i);
          face.push(segment);
          face.push(0);
        }
      }

      geo = new BufferGeometry();
      let P = [];
      for (let i in bottomPos) {
        P.push(bottomPos[i].x);
        P.push(bottomPos[i].y);
        P.push(bottomPos[i].z);
      }
      let Float = new Float32Array(P); //TypeError: Float32Array is not a constructor
      geo.setAttribute("position", new BufferAttribute(Float, 3));
      //面片信息
      Float = new Uint16Array(face);
      geo.index = new BufferAttribute(Float, 1);
    }
    //mat
    {
      let c = new Color(color);
      mat = new ShaderMaterial({
        uniforms: {
          targetColor: { value: new Vector3(c.r, c.g, c.b) },
          height: { value: height },
        },
        side: DoubleSide,
        transparent: true,
        //depthTest: false,
        depthWrite: false,
        vertexShader: [
          "varying vec3 modelPos;",
          "void main() {",
          "   modelPos = position;",
          "        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",
          "}",
        ].join("\n"),
        fragmentShader: [
          "uniform vec3 targetColor;",
          "uniform float height;",
          "varying vec3 modelPos;",

          "void main() {",
          "   gl_FragColor = vec4(targetColor.xyz,(1.0 - modelPos.y/height)*(1.0 - modelPos.y/height));",
          "}",
        ].join("\n"),
      });
    }

    let mesh = new Mesh(geo, mat);
    mesh.renderOrder = 100;
    return mesh;
  }
}
